/**
 * Still shown before the public home hero video starts.
 * An empty string omits the attribute. `poster=""` can request the page URL.
 */
export const HOME_HERO_POSTER = '/images/hero/destinations-hero-poster.jpg';

export function homeHeroPosterAttribute(
  poster: string = HOME_HERO_POSTER,
): { poster: string } | undefined {
  if (poster === '') {
    return undefined;
  }
  return { poster };
}

/**
 * Same-origin re-encodes of the 24 MB storage original (`cities/hero/destinations-hero.mp4`,
 * 1080p, ~21.7 Mbps, with an unused audio track). Same 9 s clip, H.264, no audio, faststart.
 * Desktop keeps 1080p (~3 MB); the phone hero uses a 720p cut (~1.7 MB) because
 * `object-cover` crops most of the width away on a portrait screen anyway.
 */
export const HOME_HERO_VIDEO = '/media/hero/destinations-hero-1080.mp4';
export const HOME_HERO_VIDEO_MOBILE = '/media/hero/destinations-hero-720.mp4';
